export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: 'Galgame资源大全是什么网站？',
    answer: 'Galgame资源大全是一个专注于galgame资源聚合的中文网站，提供galgame资源下载导航、汉化补丁信息、推荐合集与新手入门指南。我们致力于为galgame爱好者打造一站式的资源查找平台，涵盖经典名作与最新热门作品，帮助玩家快速找到心仪的galgame资源。',
  },
  {
    question: '网站上的galgame资源如何下载？',
    answer: '本网站作为资源导航平台，会为每款galgame提供详细的资源获取指引，包括官方购买渠道、汉化补丁下载链接和资源分享平台入口。我们会标注每个资源的来源和可靠性，方便用户根据自己的需求选择合适的获取方式。所有资源链接均会定期检查更新，确保有效性。',
  },
  {
    question: 'galgame汉化补丁在哪里可以找到？',
    answer: '我们整理了各大知名汉化组（如澄空学园、心愿屋等）的最新汉化补丁信息，按作品分类展示。在每款游戏的详情页中，你可以找到对应汉化补丁的下载链接、安装教程以及版本说明。同时我们也会关注汉化进度，及时更新最新的汉化动态。',
  },
  {
    question: '我是galgame新手，应该从哪里开始？',
    answer: '建议新手玩家从我们的"新手入门完全指南"开始阅读，了解galgame的基本概念和术语。然后可以根据自己的兴趣偏好，从推荐入坑作品列表中选择适合的作品。经典的入坑作品包括《CLANNAD》、《命运石之门》等。我们也会持续更新新手向的内容，帮助新玩家顺利入门。',
  },
  {
    question: '网站上的文章多久更新一次？',
    answer: '我们的编辑团队会保持每周至少更新2-3篇高质量文章，内容涵盖新作评测、经典回顾、汉化资讯、行业动态等。同时我们会根据galgame新作的发售节奏和汉化进度，及时发布相关的推荐和教程内容，确保信息的时效性和实用性。',
  },
  {
    question: '如何联系Galgame资源大全的运营团队？',
    answer: '你可以通过"关于我们"页面提供的联系方式与我们取得联系，包括电子邮箱和社交媒体账号。我们欢迎galgame爱好者提供资源信息、投稿评测文章或提出网站改进建议，共同建设更好的galgame资源社区。',
  },
];